<template>
  <div class="disabled-input whitespace-pre-wrap">{{ value }}</div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: () => '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/disabled-input.scss';
</style>
